export const SUPER_ADMIN = 'super-admin';
export const PARTNER_ADMIN = 'partner-admin';